export const PRODUCTION_API_URL =
  "https://science-tutor-production.up.railway.app/api";

const LOOPBACK_HOSTS = new Set([
  "localhost",
  "127.0.0.1",
  "::1",
]);

function getBrowserHostname() {
  if (typeof window === "undefined") {
    return "";
  }

  return window.location.hostname;
}

function targetsLoopbackHost(url) {
  try {
    return LOOPBACK_HOSTS.has(
      new URL(url).hostname.toLowerCase()
    );
  } catch {
    return false;
  }
}

export function resolveApiBaseUrl({
  configuredUrl = process.env.REACT_APP_API_URL,
  browserHostname = getBrowserHostname(),
} = {}) {
  const configured = String(
    configuredUrl || ""
  ).trim();
  const hostname = String(
    browserHostname || ""
  ).toLowerCase();
  const isLiveBrowser =
    hostname && !LOOPBACK_HOSTS.has(hostname);

  if (
    configured &&
    !(
      isLiveBrowser &&
      targetsLoopbackHost(configured)
    )
  ) {
    return configured.replace(/\/+$/, "");
  }

  return PRODUCTION_API_URL;
}

export const API_BASE_URL =
  resolveApiBaseUrl();
